import FilterCard from "Components/Common/FilterBar/FilterCard/FilterCard";
import ToggleBar from "Components/ToggleBar/ToggleBar";
import ToggleOption from "Components/ToggleBar/ToggleOption/ToggleOption";
import React from "react";
import i18n from "Translations/i18n";

interface IProps {
    title: string;
    value?: boolean;
    onChange: (value?: boolean) => void;
}

const YesNoFilterCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <FilterCard title={props.title} onClear={props.value !== undefined ? () => props.onChange(undefined) : undefined}>
        <ToggleBar allowUndefined={true} selectedItem={props.value} onChange={props.onChange} fullWidth={true} small={true}>
            <ToggleOption value={true}>{i18n.t("common.yes")}</ToggleOption>
            <ToggleOption value={false}>{i18n.t("common.no")}</ToggleOption>
        </ToggleBar>
    </FilterCard>
);

export default YesNoFilterCard;


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterCards/YesNoFilterCard/YesNoFilterCard.tsx